import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cva } from "class-variance-authority";
import * as React from "react";
import { wrapperTypographyClassNames } from "../../typography";
import { cn } from "../../lib/utils";
const badgeStyles = cva(`inline-flex max-w-max items-center justify-center gap-1 rounded-full border py-[3px] whitespace-nowrap transition-colors ${wrapperTypographyClassNames.badge}`, {
    variants: {
        variant: {
            default: "border-[#353e61] bg-[rgba(29,41,61,0.4)] text-foreground",
            destructive: "border-[#ff0018] bg-[rgba(239,68,68,0.2)] text-foreground",
            success: "border-[#22c55e] bg-[rgba(34,197,94,0.4)] text-white",
            warning: "border-[#fdae00] bg-[rgba(253,174,0,0.4)] text-foreground",
            primary: "border-[#1c62eb] bg-[rgba(28,98,235,0.4)] text-white",
        },
    },
    defaultVariants: {
        variant: "default",
    },
});
const BADGE_PADDING_CLASSES = {
    left: "pl-[7px] pr-[9px]",
    none: "px-[11px]",
    right: "pl-[9px] pr-[7px]",
};
const SECONDARY_LABEL_CLASSES = {
    default: "text-muted-foreground",
    destructive: "text-[#ff0018]",
    success: "text-[#22c55e]",
    warning: "text-[#fdae00]",
    primary: "text-[#1c62eb]",
};
function getIconPosition({ leftIcon, rightIcon, }) {
    if (leftIcon) {
        return "left";
    }
    if (rightIcon) {
        return "right";
    }
    return "none";
}
function capitalizeBadgeText(value) {
    return value.replace(/(\S)/, (match) => match.toLocaleUpperCase());
}
function formatBadgeNode(node) {
    if (typeof node === "string") {
        return capitalizeBadgeText(node);
    }
    if (Array.isArray(node)) {
        return node.map(formatBadgeNode);
    }
    return node;
}
export function badgeVariants({ variant, } = {}) {
    return badgeStyles({
        variant: variant ?? "default",
    });
}
export function Badge({ children, className, leftIcon, rightIcon, secondaryLabel, variant, wrap = false, ...props }) {
    const normalizedVariant = variant ?? "default";
    const iconPosition = getIconPosition({ leftIcon, rightIcon });
    const label = formatBadgeNode(children);
    return (_jsxs("div", { "data-slot": "badge", "data-variant": normalizedVariant, className: cn(badgeVariants({ variant: normalizedVariant }), BADGE_PADDING_CLASSES[iconPosition], wrap &&
            "max-w-full min-w-0 flex-wrap justify-start rounded-[12px] text-left whitespace-normal", className), ...props, children: [leftIcon ? (_jsx("span", { className: "shrink-0 [&>svg]:size-3", children: leftIcon })) : null, wrap ? (_jsx("span", { className: "min-w-0 [overflow-wrap:anywhere]", children: label })) : (label), secondaryLabel ? (_jsx("span", { className: cn(wrap
                    ? `min-w-0 [overflow-wrap:anywhere] ${wrapperTypographyClassNames.badgeSecondary}`
                    : `shrink-0 ${wrapperTypographyClassNames.badgeSecondary}`, SECONDARY_LABEL_CLASSES[normalizedVariant]), children: formatBadgeNode(secondaryLabel) })) : null, rightIcon ? (_jsx("span", { className: "shrink-0 [&>svg]:size-3", children: rightIcon })) : null] }));
}
